<template>
	<v-card v-if="reduce.length"
		elevation="0">
		<v-card-title class="text-h6">{{ title }}</v-card-title>
		<v-card-subtitle class="text-subtitle-2">{{ subtitle }}</v-card-subtitle>

		<v-card-text>
			<v-simple-table dense>
				<template v-slot:default>
					<thead>
						<tr>
							<th width="80%" class="text-left">Найменування факторів, які визначають умови експлуатації</th>
							<th width="20%" class="text-left">Дз, %</th>
							<!-- <th width="30%" class="text-left">Опис</th> -->
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, index) in reduce" :key="index" >
							<td>{{ item.name }}</td>
							<td>{{ item.type.val }}</td>
						</tr>
					</tbody>
				</template>
			</v-simple-table>
		</v-card-text>
	</v-card>
</template>

<script>
export default {
	data: () => ({
		title: 'Фактори, що впливають на процент зниження вартості КТЗ',
		subtitle: 'Чинники, що використовуються у розрахунку вартості:',
	}),

	props: {
		item: { type: Object, default: () => {}},
	},

	computed: {
		reduce() {
			return this.item.hasOwnProperty('uses') ? this.item.uses.filter((item) => !item.type.growing && !item.type.element ): [];
		},
	},

	methods: {
		
	},
}
</script>